import React from "react";
import "./InterviewAccuracy.css";
import { useNavigate, useParams } from "react-router-dom";

const InterviewAccuracy = () => {
    const navigate = useNavigate();
    const { id } = useParams();
  
  return (
    <div className="accuracy-container">
      <h1>Accuracy (How Correct Was Your Answer?)</h1>

      <section className="accuracy-section">
        <h2>What is Accuracy?</h2>
        <p>
          Accuracy measures how many of your answers were correct out of the total
          questions asked. It’s a direct reflection of your understanding of the material.
        </p>
      </section>

      <section className="accuracy-section">
        <h2>Why is it Important?</h2>
        <p>
          It shows your true performance. If your accuracy is high, you have a
          strong grasp of the content. If it's low, it means there’s room for
          improvement.
        </p>
      </section>

      <section className="accuracy-section">
        <h2>How is it Measured?</h2>
        <p>
          <strong>Formula:</strong> 
          <br />
          Accuracy = (Correct Answers / Total Questions) × 100
          <br />
          The system calculates how many correct answers you got out of all the
          questions and gives you a percentage.
        </p>
      </section>

      <section className="accuracy-section">
        <h2>Real-life Example:</h2>
        <p>
          If you answer 17 out of 20 questions correctly, your accuracy is 85%.
          It means you understood most of the material, but could improve on the 3
          questions you missed.
        </p>
      </section>

      <section className="accuracy-section">
        <h2>What it Tells Us:</h2>
        <p>
          High accuracy means you're doing well and understand the content. Low
          accuracy highlights areas that might need more practice or focus.
        </p>
      </section>

      <section className="confidence-section">
      <button className="certificate-btn" onClick={() =>  navigate(`/enrolledCourse/ai-interview/${id}/result`)}>Go Back</button>
      </section>
    </div>
  );
};

export default InterviewAccuracy;
